module.exports = __webpack_public_path__ + "static/img/004_dron.73beb9f4.jpg";